import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './Book.module.css';
import { useNavigate } from "react-router-dom";
import {Image} from 'react-bootstrap';
import noImagePng from'../asset/no-image.png';
import musicPlayer from'../asset/music-player.png';
import imagePoolOpenPng from'../asset/image-pool-open.png';
import progressPng from'../asset/progress.png';
import oppositeArrowsPng from'../asset/opposite-arrows.png';
import reorderPng from'../asset/reorder.png';
import deletePng from'../asset/delete.png';
import clickPng from'../asset/click.png';
import addCirclePng from'../asset/add-circle.png';
import { useDropzone } from "react-dropzone";
import {Form} from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';
import ClipLoader from "react-spinners/ClipLoader";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import babyPng from'../asset/baby.png';
import phonicsPng from'../asset/communication.png';
import poemPng from'../asset/poetry.png';
import uncheckedPng from'../asset/unchecked.png';

import SpeakingHints from './SpeakingHints.js'
import VIPWriting from './VIPWriting.js'
import ListeningPartb from './ListeningPartb.js'
import ComplexSentence from './ComplexSentence.js'
import ItemQuestionsOverview from './ItemQuestionsOverview.js'
import SpeakingAnswers from './SpeakingAnswers.js'
import ItemQuestions from './ItemQuestions.js'
import KeyListening from './KeyListening.js'
import KeyItemBasic from './KeyItemBasic.js'
import ShortReadingOverride from './ShortReadingOverride.js'
import WordList from './WordList.js'
import { Link } from "react-router-dom";

import {ItemConstant, ItemObjectList} from '../middleware/MyConstant';
import {setGeneralStorage, getGeneralStorage} from '../middleware/dataStorage';


const WordsDetail = ({itemId, wordOrigin}) => {
		let wordListFormat = getGeneralStorage('wordListFormat') ?? "qmeaning";
		let wordListPage = getGeneralStorage('wordListPage') ?? 1;
		let wordListLimit = getGeneralStorage('wordListLimit') ?? 100;
		let wordListOrderBy = getGeneralStorage('wordListOrderBy') ?? "alphabet";
	
		return (<div>
			<WordList target={"item"}
				key={wordOrigin}
				format = {wordListFormat}
				wordOrigin = {wordOrigin}
				page={wordListPage}
				limit={wordListLimit}
				itemId={itemId}
				orderBy={wordListOrderBy}
				setParamCall={() => {}}
				showItemSearch={false}
				/>
		</div>)
}



export default function Book(prop) {	
	const navigate = useNavigate();
	
  let itemId = prop.itemId;
	const [rawData, setRawData] = useState({
		itemType:"", thumbnailPath:"https://ehla-media-bucket.s3.amazonaws.com/cms/ansvideo_new_test2.jpg"
	})
	const [rawSectionsData, setRawSectionsData] = useState([]);
	const [sectionsData, setSectionsData] = useState([]);
	
	const [imagesPoolData, setImagesPoolData] = useState([]);
	
	const [imgAsc, setImgAsc] = useState(true);
	const [advModify, setAdvModify] = useState(false);
	
	const [wordInput, setWordInput] = useState("");
	const [itemWords, setItemWords] = useState([]);
	
	
	const [toggle, setToggle] = useState();
	
	const setToggleValue = (toggleValue) => {
		setToggle(toggleValue);
		setGeneralStorage('itemBasicToggle', toggleValue)
	}
	
	
	const [imageSelectionData, setImageSelectionData] = useState({
		show:false,
		cSectionData:null,
	});
	const [uploadImageData, setUploadImageData] = useState({
		show:false,
	});
	
	const [wordToggle, setWordToggle] = useState(1)
	const [wordOrigin, setWordOrigin] = useState(getGeneralStorage('wordListWordOrigin') ?? 1)
	
	const [tag, setTag] = useState("baby");
	const [phrase, setPhrase] = useState(null);
	
	const [cClickImage, setCClickImage] = useState(null);
	
	
	const [shortReadingOverrideData, setShortReadingOverrideData] = useState(null); 

	// FETCH: Get short reading override data by itemId (1st API call)
	const fetchOverrideData = async () => {
	try {
		const res = await getData(`item/getShortReadingOverride?itemId=${itemId}`, navigate);
		const data = res.data || null;
		setShortReadingOverrideData(data);
	} catch (error) {
		console.error("Failed to fetch short reading override:", error);
	}
	};
	
	useEffect(() => {
		if (itemId) fetchOverrideData();
	}, [itemId]);
	const updateOrdering = (id, ordering) => {
		let obj = {
			id, ordering
		}
		
		postData("item/updateBookOrdering", obj, navigate); 
	}
	
	
	const loadThumbnail = (type) =>{
		
		let obj = {
			itemId, type, 'imgPoolId' : cClickImage,
		}
		postData("item/updateThumbnailPathByPooling", obj, navigate); 
		setCClickImage(null);
	}
	
	const loadAllBookPages = async () =>{
		
		let obj = {
			'itemId' : itemId,
			'imgPoolId' : cClickImage,
		}
		
		let data = await postData("item/updateBookAllPagesByPooling", obj, navigate); 
		let imagePath = data.data;
		
		let tmpRawSectionsData = rawSectionsData;
		tmpRawSectionsData.forEach((e)=>{
			e.imgPath = "https://ehla-media-bucket.s3.amazonaws.com/" + imagePath
		})
		setRawSectionsData([...tmpRawSectionsData])
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData.forEach((e)=>{
			e.imgPath = "https://ehla-media-bucket.s3.amazonaws.com/" + imagePath
			console.log(e.imgPath);
		})
		setSectionsData([...tmpSectionsData])
		
		setCClickImage(null);
	}
	
	
	const getWordsByItemId = () => {
		getData('wordApi/getWordsByItemId?itemId=' + itemId, navigate)
		.then(res => {
				setItemWords(res.data);
			}
		);	
	}
	
	
	
	const UploadImageModal = ({itemId}) => {
		
		return (
			<div className={uploadImageData.show ? s['modal'] : s['modal-hide']}>
				<div className={s['modalContentWrapper']}>			
					<div className={s.reverseIconHolder} onClick={()=>setImgAsc(!imgAsc)}><img className={s.srtIconLarge} src={oppositeArrowsPng} /></div>
					<h1>drag and drop</h1>
					
					
					<Dropzone className={s.dropzoneHolder} />
					{
						(cClickImage) && (<div className={s['uploadImage_loadThumbnailBtn_holder']}>
							<GreenButton isEnabled={true} clickedAction={()=>{loadThumbnail("basic")}} bText={"To Thumbnail"} />
							<GreenButton isEnabled={true} clickedAction={()=>{loadThumbnail("header")}} bText={"To Thumbnail Header"} />
								
							<div style={{margin:"0 10px 0 auto"}}>
							<BlueButton isEnabled={true} clickedAction={()=>{loadAllBookPages()}} bText={"load all book pages"} />
								</div>
						</div>)
						
						
					}
					
					<div className={s.modalSectionThumbnailPathHolder}>
					{
						imgAsc && (imagesPoolData.map((v)=>(
								<Image key={v.id} className={(cClickImage == v.id) ? s['modal-section-thumbnail-path-chosen'] : s['modal-section-thumbnail-path']} fluid
									onClick={()=>setCClickImage(v.id)}
									src={v.imagePath} rounded />
							))
						)
					}
					{
						!imgAsc && ([...imagesPoolData].reverse().map((v)=>(
								<Image key={v.id} className={(cClickImage == v.id) ? s['modal-section-thumbnail-path-chosen'] : s['modal-section-thumbnail-path']} fluid
									onClick={()=>setCClickImage(v.id)}
									src={v.imagePath} rounded />
							))
						)
					}
					
					
					</div>
					
					
				</div>
				<div className={s['modal-backdrop']} onClick={()=>{ setUploadImageData({show:false})}}/>
			</div>);
	}
	
	function Dropzone({ open, poolsParam }) {
		const onDrop = useCallback(async (acceptedFiles) => {			
			for(let i = 0; i<acceptedFiles.length; i++) {
				try {
					const data = new FormData();
					data.append("itemId", itemId);
					data.append("imagefile", acceptedFiles[i]);
					let res = await postFormData("utility/uploadBookImagePath", data, navigate);
					
					setImagesPoolData(p => [...p, res.data])
					
				} catch (err) {
					console.log(err);
				}
			}
		}, [])
		
		const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone({onDrop,  accept: {'image/png': ['.png', '.jpg', '.jpeg']}});
	
		return (<>
				<div className={s["dropzone-container"]}>
					<div {...getRootProps({ className: "dropzone" })}>
						<input {...getInputProps()} />
						<div>
							{isDragActive ? (
								<p className="dropzone-content">
									Release to drop the files here
								</p>
							) : (
								<p className="dropzone-content">
									Drag’n’drop some files here, or click to select files
								</p>
							)}
							<button type="button" onClick={open} className={s["dropzone-btn"]}>
							Click to select files
							</button>
						</div>
					</div>
				</div>
			</>
		);
	}
	
	
	const updateSectionThumbnailPath = async (sId, rImage) => {
		
		let obj = {
			'sectionId' : sId,
			'imgPath' : rImage,
		}
		await postData("bookApi/updateBookSectionImage", obj, navigate); 
		
		let tmpRawSectionsData = rawSectionsData;
		tmpRawSectionsData.forEach((e)=>{
			if (e.id == sId) {
				e.imgPath = rImage
			}
		})
		setRawSectionsData([...tmpRawSectionsData])
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData.forEach((e)=>{
			if (e.id == sId) {
				e.imgPath = rImage
			}
		})
		setSectionsData([...tmpSectionsData])
	}
	
	
	const SoundPlayer = ({soundFile}) => {
    var savingCurrencySound = soundFile;
    var playCurrencySound = () => {     
        var audio = new Audio(savingCurrencySound);
        audio.play();
    }
    return (
			<Image className={s['music-player']} fluid onClick={ () => playCurrencySound() }
				src={musicPlayer} rounded />
		
    );
	}
	
	const generateArticleComplexSentence = async (cSectionData, indexV) => {
		let bookSectionId = cSectionData.id
		
		let obj = { bookSectionId }
		
		await postData("complexSentenceApi/genArticleComplexSentenceByBookSectionId", obj, navigate);
	}	
	
	const ImageSectionModal = ({itemId, cSectionData}) => {
		const [rImage, setRImage] = useState();
		if (!cSectionData) {
			return (<></>);
		}
		
		
		let sId = cSectionData.id;
		let imgPath = cSectionData.imgPath;
		
		
		return (
			<div className={imageSelectionData.show ? s['modal'] : s['modal-hide']}>
				<div className={s.modalContentWrapper}>			
					<div className={s.reverseIconHolder} onClick={()=>setImgAsc(!imgAsc)}><img className={s.srtIconLarge} src={oppositeArrowsPng} /></div>	
					<div className={s['modal-section-obj-holder']}>
						<div className={s['modal-section-obj-holder-l2']}>
							<div>
								{sId}
							</div>
							<div>
								<Image className={s['modal-section-thumbnail-path']} fluid
									src={(imgPath) ? imgPath :noImagePng} rounded />
							</div>
							{
								(rImage) && (<>
								<div>
									<div className={s['middle-div']}>
										<div>
											<div className={s.labelChangeTo}>Change To</div>
											<div className="general-red-btn general-red-btn-default" onClick={() => updateSectionThumbnailPath(sId, rImage)}>Confirm?</div>
										</div>
									</div>							
									</div>
									<div>
										<Image className={s['modal-section-thumbnail-path']} fluid src={rImage} rounded />
									</div>
								</>)
							}
						</div>
						
					</div>
						<div className={s['modal-section-thumbnail-path-holder']}>
						{
							imgAsc && (imagesPoolData.map((v)=>(
									<Image onClick={() => setRImage(v.imagePath)} key={v.id} className={s['modal-section-thumbnail-path']} fluid
										src={v.imagePath} rounded />
							)))
						}
						{
							!imgAsc && ([...imagesPoolData].reverse().map((v)=>(
									<Image onClick={() => setRImage(v.imagePath)} key={v.id} className={s['modal-section-thumbnail-path']} fluid
										src={v.imagePath} rounded />
							)))
						}
						</div>
					
					
					
				</div>
				<div className={s['modal-backdrop']} onClick={()=>{ setImageSelectionData({cSectionData:null, show:false})}}/>
			</div>);
	}
	
	
	const createNewSection = async () => {
		let obj = { 'itemId' : itemId }
		postData("bookApi/createBookSection", obj, navigate).then(res => {
			let isFound = false;
			for (let i=0; i<rawSectionsData.length; i++) {
				if (rawSectionsData[i].id == res.data.id) {
					isFound = true;
					break;
				}
			}
			
			if (!isFound) {
				console.log(rawSectionsData);
				console.log(sectionsData);
				let newArr = rawSectionsData;
				newArr.push(JSON.parse(JSON.stringify(res.data)));
				setRawSectionsData([...newArr])
				
				console.log(newArr);
				newArr = sectionsData;
				newArr.push(JSON.parse(JSON.stringify(res.data)));
				setSectionsData([...newArr])
				console.log(newArr);
			}
		
		});
	}
	
	const fetchData = () => {
		getData('item/getByItemId?itemId=' + itemId, navigate)
		.then(res => {
				setRawData({
					itemType:res.data.itemType,
					thumbnailPath:res.data.thumbnailPath,
				});
				
				if (ItemConstant.BookItemIts.includes(res.data.itemType)) {
					setRawSectionsData(res.data.detail.sections);
					//bill nested clone
					setSectionsData(JSON.parse(JSON.stringify(res.data.detail.sections)));
				}
				
				let tmpTags = res.data.tags;
				
				tmpTags.forEach(t => {
					if (['baby','phonics','poem'].includes(t)) {
						setTag(t);
					} else if (['Phrase 1','Phrase 2','Phrase 3','Phrase 4'].includes(t)) {
						setPhrase(t);
					}
				})
				
				setImagesPoolData(res.data.detail.imagesPool);
				
				let defaultToggle = getGeneralStorage('itemBasicToggle') ?? 1;
				if (res.data.itemType == '93') {
					if (![2,3,5,6, 10, 11].includes(parseInt(defaultToggle))) {
						setToggle(11);
					} else {
						setToggle(defaultToggle);
					}
					
				} else if (ItemConstant.ListeningLabelIts.includes(res.data.itemType)) { // listening + podcast
					if (![2,3,5,6, 10].includes(parseInt(defaultToggle))) {
						setToggle(5);
					} else {
						setToggle(defaultToggle);
					}
				} else if (ItemConstant.SpeakingAnswerIts.includes(res.data.itemType)) { // speaking
					if (![1,2,3,4,6,7,8, 10].includes(parseInt(defaultToggle))) {
						setToggle(2);
					} else {
						setToggle(defaultToggle);
					}
				} else if (ItemConstant.VIPWritingIts.includes(res.data.itemType)) {
					if (![1,2,3,6,8,9, 10].includes(parseInt(defaultToggle))) {
						setToggle(1);
					} else {
						setToggle(defaultToggle);
					}
					
				} else if (ItemConstant.ListeningPartbIts.includes(res.data.itemType)) {
					if (![1,2,3,6,8,9, 10, 12].includes(parseInt(defaultToggle))) {
						setToggle(1);
					} else {
						setToggle(defaultToggle);
					}
					
				} else {
					if (![1,2,3,6,8, 10].includes(parseInt(defaultToggle))) {
						setToggle(1);
					} else {
						setToggle(defaultToggle);
					}
				}
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const addSectionSentence = async(sectionId) => {
		let obj = { 'itemId' : itemId, 'bookSectionId' : sectionId }
		let res = await postData("bookApi/createBookSectionSentence", obj, navigate)
				
		rawSectionsData.forEach((e)=>{
			if (e.id == sectionId) {
				e.sectionSentences = [...e.sectionSentences, {
						"id": res.data.id,
						"sentence": "", 
						"sentenceJson": {"hk":""}, 
						"soundTrack": null,
						"srtJson": null,
						"isSimple":true,
						"isAdvanced":false,
						"ordering": res.data.ordering,
				}];
			}
		})
		
		setRawSectionsData([...rawSectionsData])
		
		sectionsData.forEach((e)=>{
			if (e.id == sectionId) {
				e.sectionSentences = [...e.sectionSentences, {
					"id": res.data.id,
					"sentence": "",
					"sentenceJson": {"hk":""}, 
					"soundTrack": null,
					"srtJson": null,
					"isSimple":true,
					"isAdvanced":false,
					"ordering": res.data.ordering,
				}];
			}
		})
		setSectionsData([...sectionsData])		
	}
	
	
	const updateSectionSentence = async (indexV, indexSS, ssId, ssSentence) => {
		ssSentence = ssSentence.trim()
		let obj = {
			'ssId' : ssId,
			'sentence' : ssSentence,
		}
		await postData("bookApi/updateSectionSentence", obj, navigate); 
		let tmpRawSectionsData = rawSectionsData;
		tmpRawSectionsData[indexV].sectionSentences[indexSS].sentence = ssSentence;
		tmpRawSectionsData[indexV].sectionSentences[indexSS].lastAction = "TEXT";
		
		setRawSectionsData([...tmpRawSectionsData])	
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].sentence = ssSentence;
		tmpSectionsData[indexV].sectionSentences[indexSS].lastAction = "TEXT";
		
		setSectionsData([...tmpSectionsData])		
	}
	
	
	const deploySectionSentenceByAudio = async (indexV, indexSS, ssId, targetLink) => {
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].lastAction = "JOB";
		
		setSectionsData([...tmpSectionsData])		
		
		let tmpRawSectionsData = rawSectionsData;
		tmpRawSectionsData[indexV].sectionSentences[indexSS].lastAction = "JOB";
		
		setRawSectionsData([...tmpRawSectionsData])	
		
		let obj = { ssId, targetLink }
		let res = await postData("bookApi/deploySectionSentenceByAudio", obj, navigate); 
		
		
	}
	
	const deploySectionSentence = async (indexV, indexSS, ssId) => {
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].lastAction = "JOB";
		
		setSectionsData([...tmpSectionsData])		
		
		let tmpRawSectionsData = rawSectionsData;
		tmpRawSectionsData[indexV].sectionSentences[indexSS].lastAction = "JOB";
		
		setRawSectionsData([...tmpRawSectionsData])	
		
		let obj = {
			'ssId' : ssId,
		}
		let res = await postData("bookApi/deploySectionSentence", obj, navigate); 
		
		
	}
	
	
	const removeSectionSentence = async (indexV, ssId) => {
		
		let obj = {
			'ssId' : ssId
		}
		await postData("bookApi/removeSectionSentence", obj, navigate); 
		let tmpRawSectionsData = rawSectionsData;
		let rawSubSection = tmpRawSectionsData[indexV].sectionSentences.filter((e)=> (e.id !== ssId))
		tmpRawSectionsData[indexV].sectionSentences = rawSubSection;
		setRawSectionsData([...tmpRawSectionsData])
		
		let tmpSectionsData = sectionsData;
		let subSection = tmpSectionsData[indexV].sectionSentences.filter((e)=> (e.id !== ssId))
		tmpSectionsData[indexV].sectionSentences = subSection;
		setSectionsData([...tmpSectionsData])
	}
	
	const updateSrt = async(indexV, indexSS, ssId) => {		
		let srtJson = JSON.stringify(sectionsData[indexV].sectionSentences[indexSS].srtJson);
		let obj = {
			'ssId' : ssId,
			'srtJson' : srtJson,
		}
		await postData("bookApi/updateSectionSentenceSrtJson", obj, navigate); 
		
		rawSectionsData[indexV].sectionSentences[indexSS].srtJson = JSON.parse(srtJson);
		setRawSectionsData([...rawSectionsData]);
	}
	
	const toggleIndex = (indexV, indexSS, indexSj, indexC) => {
		let tmp = sectionsData[indexV].sectionSentences[indexSS].srtJson[indexSj];
		if (!tmp['highlight']) {
			tmp['highlight'] = [indexC];
		} else if (tmp['highlight'].includes(indexC)) {
			const index = tmp['highlight'].indexOf(indexC);
			if (index > -1) {
				tmp['highlight'].splice(index, 1);
			}
			if (tmp['highlight'].length==0) {
				delete tmp['highlight'];
			}
			
		} else {
			tmp['highlight'].push(indexC);
		}
		
		sectionsData[indexV].sectionSentences[indexSS].srtJson[indexSj] = tmp;
		setSectionsData([...sectionsData]);
	}
	
	const isToggleChar = (indexV, indexSS, indexSj, indexC) => {
		if (!sectionsData[indexV].sectionSentences[indexSS].srtJson[indexSj].highlight) {
			return false;
		}
		//bill includes
		if (sectionsData[indexV].sectionSentences[indexSS].srtJson[indexSj].highlight.includes(indexC)) {
			return true;
		}
		return false;
	}
	
	
  const [value, setValue] = useState('Sample Text');
	
	const [cDrag, setCDrag] = useState({
		indexV:0,
		indexSS:0,
		indexSj:0,
	});
	
	const dragOver = (e) => {
		//console.log(e);
	}
	
	const changePhrase = async (phrase) => {
		if (phrase) {
			let obj = {
				'itemId' : itemId,
				'phrase' : phrase,
			}
			postData("bookApi/changePhrase", obj, navigate); 
		}
	}
	
	const changeTag = async (tag) => {
		let obj = {
			'itemId' : itemId,
			'tag' : tag,
		}
		postData("bookApi/changeTag", obj, navigate); 
	}
	
	const dragStart = (e, indexV, indexSS, indexSj) => {
		setCDrag({
			indexV,
			indexSS,
			indexSj});
			
	}
	
	const addWord = (indexV, indexSS) => {
		let tmp = sectionsData[indexV].sectionSentences[indexSS].srtJson;
		tmp.push({startTime: "0",word: ""});
		
		sectionsData[indexV].sectionSentences[indexSS].srtJson= tmp;
		setSectionsData([...sectionsData]);
	}
	
	const removeWord = async (wordId) => {
		
		let obj = {
			'itemId' : itemId,
			'wordId' : wordId,
		}
		await postData("wordApi/itemRemoveWord", obj, navigate); 
		getWordsByItemId();
	}
	
	
	const deleteWord = (indexV, indexSS, indexSj) => {
		let tmp = sectionsData[indexV].sectionSentences[indexSS].srtJson;
		
		tmp.splice(indexSj, 1);
		
		sectionsData[indexV].sectionSentences[indexSS].srtJson= tmp;
		setSectionsData([...sectionsData]);
	}
	
	const drop = (e, indexV, indexSS, indexSj) => {
		if (indexV != cDrag.indexV || indexSS != cDrag.indexSS) {
			return;
		}
		
		if (indexSj == cDrag.indexSj) {
			return;
		}
		
		
		let tmp = sectionsData[indexV].sectionSentences[indexSS].srtJson;
		
		let sourceElement = tmp[cDrag.indexSj];
		
		if (cDrag.indexSj < indexSj) {
			indexSj--;
		}
		
		tmp.splice(cDrag.indexSj, 1);
		
		let newTmp = [
			...tmp.slice(0, indexSj+1),
			sourceElement,
			...tmp.slice(indexSj+1)		
		];
		
		sectionsData[indexV].sectionSentences[indexSS].srtJson= newTmp;
		setSectionsData([...sectionsData]);
	}
	
	
	
	const generalItemUpload = async (selectedFile) => {
		
		try {			
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			
      let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
    } catch (err) {
			return null;
      console.log(err);
    }
		
	}
	
	const ItemTagIcon = ({itemTag}) => {
		
		switch(itemTag) {
			case "phonics":
				return (
				<Image className={s.iconSmall} fluid
					src={phonicsPng} rounded />	);
			case "baby":
				return (
				<Image className={s.iconSmall} fluid
					src={babyPng} rounded />	);
			case "poem":
				return (
				<Image className={s.iconSmall} fluid
					src={poemPng} rounded />	);
			default :
				return (
				<Image className={s.iconSmall} fluid
					src={babyPng} rounded />	);
		}
	}
	
	const saveTranslation = async (id, hk) =>  {
		if (!hk){
			return;
		}
		
		let obj = { id,  'sentence' : hk }
		await postData("bookApi/updateHkTranslation", obj, navigate); 
	}
	
	
	const [isAudioAll, setIsAudioAll] = useState(false);
	const batchAwsSoundLoad = async () => {
		setIsAudioAll(true);
		let obj = {itemId}		
		await postData("bookApi/batchAwsSoundLoad", obj, navigate); 	
		
		fetchData();
		setIsAudioAll(false);
	}
	
	const [isTranslatingAll, setIsTranslatingAll] = useState(false);
	const batchTranslateAndSave = async () => {
		setIsTranslatingAll(true);
		let i=0;
		for(const d of rawSectionsData) {
			let j=0;
			for(const s of d.sectionSentences) {
				if (s.id && !s.sentenceJson.hk) {
					await translateAndSave(i, j, s.id, s.sentence);
				}
				j++;
			}
			i++;
		}
		setIsTranslatingAll(false);
	}
	
	const batchComplexSentenceSave = async () => {
		
		let obj = { itemId }
		postData("complexSentenceApi/genArticleComplexSentenceByItemId", obj, navigate); 
	}
	
	
	
	const translateAndSave = async(indexV, indexSS, id, sentence) => {
		if (!sentence){
			return;
		}
		
		let obj = { id, sentence }
		let hk = await postData("bookApi/translateHkSentence", obj, navigate); 
		
		let tmpRawSectionsData = rawSectionsData;
		tmpRawSectionsData[indexV].sectionSentences[indexSS].sentenceJson.hk = hk.data;
		
		setRawSectionsData([...tmpRawSectionsData])
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].sentenceJson.hk = hk.data;
		setSectionsData([...tmpSectionsData])
	}
	
	const [clickAI, setClickAI] = useState(false);
	const [isCheckedAdvanced,setIsCheckedAdvanced] = useState(false);
	
	const AIWords = async () => {
		
		if (!clickAI) {
			setClickAI(true);
			let obj = {
				'itemId' : itemId,
			}
			
			postData("wordApi/itemAIWord", obj, navigate); 
		}
	}
	
	const processWords = async () => {
		if (!wordInput){
			return;
		}
		
		let obj = {
			'itemId' : itemId,
			'words' : wordInput.split(/\r?\n/),
			'difficulty' : (isCheckedAdvanced) ? "advanced" : "simple",
		}
		await postData("wordApi/itemSetWord", obj, navigate); 
		getWordsByItemId();
		setWordInput("");
	}
	
	
	const updateSentenceAddLineSpace = async (indexV, indexSS) => {
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'addLineSpace' : !sectionsData[indexV].sectionSentences[indexSS].addLineSpace,
		}
		
		await postData("bookApi/updateSentenceAddLineSpace", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].addLineSpace = !tmpSectionsData[indexV].sectionSentences[indexSS].addLineSpace;
		setSectionsData([...tmpSectionsData]);		
	}
	
	const updateSentenceIsItalic = async (indexV, indexSS) => {
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'isItalic' : !sectionsData[indexV].sectionSentences[indexSS].isItalic,
		}
		
		await postData("bookApi/updateSentenceIsItalic", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].isItalic = !tmpSectionsData[indexV].sectionSentences[indexSS].isItalic;
		setSectionsData([...tmpSectionsData]);		
	}
	
	const updateSentenceAddDivider = async (indexV, indexSS) => {
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'addDivider' : !sectionsData[indexV].sectionSentences[indexSS].addDivider,
		}
		
		await postData("bookApi/updateSentenceAddDivider", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].addDivider = !tmpSectionsData[indexV].sectionSentences[indexSS].addDivider;
		setSectionsData([...tmpSectionsData]);		
	}
	
	const updateSentenceHeaderRate = async (indexV, indexSS, headerRate) => {		
		
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'headerRate' : headerRate,
		}
		
		await postData("bookApi/updateSentenceHeaderRate", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].headerRate = headerRate;
		setSectionsData([...tmpSectionsData]);		
	}
	
	const toggleSentenceHeaderRate = async (indexV, indexSS) => {		
		let headerRate = sectionsData[indexV].sectionSentences[indexSS].headerRate;
		
		if (isValidHeaderInteger(headerRate)) {
			headerRate = 0;
		} else {
			headerRate = 1;
		}
		
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'headerRate' : headerRate,
		}
		
		await postData("bookApi/updateSentenceHeaderRate", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].headerRate = headerRate;
		setSectionsData([...tmpSectionsData]);		
	}
	
	
	const updateSentenceInterpretation = async (indexV, indexSS) => {
		let isInt = sectionsData[indexV].sectionSentences[indexSS].isInterpretation;
		isInt = !isInt;
		
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'isInterpretation' : isInt
		}
		await postData("bookApi/updateIsInterpretation", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].isInterpretation = isInt;
		setSectionsData([...tmpSectionsData]);
	}
	
	const updateSentenceLevelSimple = async (indexV, indexSS) => {
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'isAdvanced' : sectionsData[indexV].sectionSentences[indexSS].isAdvanced,
			'isSimple' : !sectionsData[indexV].sectionSentences[indexSS].isSimple,
		}
		
		await postData("bookApi/updateLevel", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].isSimple = !tmpSectionsData[indexV].sectionSentences[indexSS].isSimple;
		setSectionsData([...tmpSectionsData]);
	}
		
	const updateSentenceLevelAdvanced = async (indexV, indexSS) => {
		let obj = {
			'id' : sectionsData[indexV].sectionSentences[indexSS].id,
			'isAdvanced' : !sectionsData[indexV].sectionSentences[indexSS].isAdvanced,
			'isSimple' : sectionsData[indexV].sectionSentences[indexSS].isSimple,
		}
		
		await postData("bookApi/updateLevel", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].sectionSentences[indexSS].isAdvanced = !tmpSectionsData[indexV].sectionSentences[indexSS].isAdvanced;
		setSectionsData([...tmpSectionsData]);		
	}
		
	const updateWordLevelSimple = async (wordId, indexW) => {
		let obj = {
			'itemId': itemId,
			'wordId' : wordId,
			'isAdvanced' : itemWords[indexW].isAdvanced,
			'isSimple' : !itemWords[indexW].isSimple,
		}
		
		await postData("wordApi/updateItemWordLevel", obj, navigate); 
		
		let tmpItemWords = itemWords;
		tmpItemWords[indexW].isSimple = !tmpItemWords[indexW].isSimple;
		setItemWords([...tmpItemWords]);
	}
	const updateWordLevelAdvanced = async (wordId, indexW) => {
		let obj = {
			'itemId': itemId,
			'wordId' : wordId,
			'isAdvanced' : !itemWords[indexW].isAdvanced,
			'isSimple' : itemWords[indexW].isSimple,
		}
		
		await postData("wordApi/updateItemWordLevel", obj, navigate); 
		
		let tmpItemWords = itemWords;
		tmpItemWords[indexW].isAdvanced = !tmpItemWords[indexW].isAdvanced;
		setItemWords([...tmpItemWords]);	
	}
	
	const toggleHideParagraph = async (cSectionData, indexV) => {
		
		let obj = {
			bookSectionId:cSectionData.id,
			hide : true
		}
		
		
		postData("bookApi/toggleHideParagraph", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].advOrdering = 1;
		
		setSectionsData([...tmpSectionsData]);	
	}
	
	const toggleShowParagraph = async (cSectionData, indexV) => {
		
		let obj = {
			bookSectionId:cSectionData.id,
			hide : false
		}
		
		postData("bookApi/toggleHideParagraph", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].advOrdering = null;
		
		setSectionsData([...tmpSectionsData]);	
	}
	
	const removeImgFromSection = async (cSectionData, indexV) => {
		let obj = {
			bookSectionId:cSectionData.id
		}
		
		postData("bookApi/removeImg", obj, navigate); 
		
		let tmpSectionsData = sectionsData;
		tmpSectionsData[indexV].imgPath = null;
		setSectionsData([...tmpSectionsData]);	
	}
	



	return (<div className={s['container']}>
		<ImageSectionModal itemId={itemId} cSectionData={imageSelectionData.cSectionData} />
		
		<UploadImageModal itemId={itemId} />
		
		<div className={s.absoluteBtnHolder}>
			<Image className={s['absolute-btn']} fluid
					src={progressPng} rounded onClick={()=>{setAdvModify(!advModify)}
					}
				/>
			<Image className={s['absolute-btn']} fluid
					src={imagePoolOpenPng} rounded onClick={()=>{setUploadImageData({show:true})}
					}
				/>
		</div>
		
		<div className={s['basic']}>
			<div style={{display:"flex", alignItems:"center"}}>	
				<div >
					<li className={s.toggleOptionHolder}>
						{//theme (6)
							(ItemConstant.AllKeyItemIts.includes(rawData.itemType)) && (<ul className={(toggle == 6) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(6);}}>Theme</ul>)
						}
						{//input / book (1)
							(!([...ItemConstant.ListeningLabelIts, ...ItemConstant.VocabIts].includes(rawData.itemType))) && 
							(<ul className={(toggle == 1) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(1);}}>
								{(ItemConstant.IdeaIts.includes(rawData.itemType)) ? "Input" : "Book"}
							</ul>)
						}
						{//listening (5)
							(ItemConstant.ListeningLabelIts.includes(rawData.itemType)) && (<ul className={(toggle == 5) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(5);}}>Listening</ul>)
						}
						{//listening part b (12)
							(ItemConstant.ListeningPartbIts.includes(rawData.itemType)) && (<ul className={(toggle == 12) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(12);}}>Listening Part B</ul>)
						}
						{//VIP writing (9)
							(ItemConstant.VIPWritingIts.includes(rawData.itemType)) && (<ul className={(toggle == 9) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(9);}}>VIP Writing</ul>)
						}
						{//Complex Sentence (11)
							(ItemConstant.ComplexSentenceIts.includes(rawData.itemType)) && (<ul className={(toggle == 11) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(11);}}>Complex Sentence</ul>)
						}
						{//ideas/article (8)
							(!([...ItemConstant.ListeningLabelIts, ...ItemConstant.VocabIts].includes(rawData.itemType)) ) && 
								(<ul className={(toggle == 8) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(8);}}>
								{(ItemConstant.IdeaIts.includes(rawData.itemType)) ? "Ideas" : "Article"}
							</ul>)
						}
						
						{//words (2)
							(<ul className={(toggle == 2) ? s.toggleOptionOn : ""} onClick={()=>{
								setToggleValue(2);
								if (itemWords.length == 0) {
									getWordsByItemId();
								}
							}}>Words</ul>)
						}
						
						{//questions (3)
							(<ul className={(toggle == 3) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(3);}}>Questions</ul>)
						}
						{//questions overview (3)
							(<ul className={(toggle == 10) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(10);}}>Questions Overview</ul>)
						}
						
						{//Speaking Hints (4)
							(ItemConstant.SpeakingAnswerIts.includes(rawData.itemType)) && (<ul className={(toggle == 4) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(4);}}>Speaking Hints</ul>)
						}		
						{//Speaking Answers (7)
							(ItemConstant.SpeakingAnswerIts.includes(rawData.itemType)) && (<ul className={(toggle == 7) ? s.toggleOptionOn : ""} onClick={()=>{setToggleValue(7);}}>Speaking Answers</ul>)
						}
					</li>
				</div>
				
				{
					(rawData.itemType == '70') && (<div style={{display:"flex"}}>
						<ItemTagIcon itemTag={tag} />
						<Form.Select style={{marginLeft:"5px"}} value={tag} onChange={(e)=>{
							changeTag(e.target.value)
							setTag(e.target.value);
						}}>
							<option value={"baby"}>baby</option>
							<option value={"phonics"}>phonics</option>
							<option value={"poem"}>poem</option>
						</Form.Select>
					</div>)
				}
				
				{
					(tag == 'phonics') && (<div style={{display:"flex"}}>
						<Form.Select style={{marginLeft:"5px"}} value={phrase} onChange={(e)=>{
							changePhrase(e.target.value)
							setPhrase(e.target.value);
						}}>
							<option value={""}>select phrase</option>
							<option value={"Phrase 1"}>Phrase 1</option>
							<option value={"Phrase 2"}>Phrase 2</option>
							<option value={"Phrase 3"}>Phrase 3</option>
							<option value={"Phrase 4"}>Phrase 4</option>
						</Form.Select>
					</div>)
				}
				
			</div>
		</div>
		
		{ 
		// Also fix the conditional below!
		([1, 3, 8, 10].includes(Number(toggle)) && rawData.itemType == 73 && shortReadingOverrideData) && (
			<div style={{padding:"10px", marginBottom:"20px",border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: ".25rem"}}>	
			<ShortReadingOverride itemId={itemId} />
			</div>
		)
		}
		{ (toggle == 1 && !(rawData.itemType == 73 && shortReadingOverrideData)) && (<div>
		<div style={{position:"relative"}}>
			<div className={s.batchUpdate}>
				<div style={{marginRight:"20px"}}>
					<BlueButton isEnabled={true} clickedAction={()=>batchComplexSentenceSave()} bText={"Complex Sentence ALL"} 
					isLoading={isTranslatingAll}
					/>
				</div>
				<div style={{marginRight:"20px"}}>
					<BlueButton isEnabled={true} clickedAction={()=>batchTranslateAndSave()} bText={"Translate ALL"} 
					isLoading={isTranslatingAll}
					/>
				</div>
				<div>
					<BlueButton isEnabled={true} clickedAction={()=>batchAwsSoundLoad()} bText={"Audio ALL"} 
					isLoading={isAudioAll}
					/>
				</div>
			</div>
		</div>


		<div className={s['section-container']}>
			<div>
			{
				sectionsData.map((v, indexV)=>{
					return (
						
						<div className={s['ordering-main-holder']}>
								<div style={{padding:"10px", borderBottom:"1px solid #f28e1b"}}>
									<div style={{margin:"0 10px", display:"flex", alignItems:"center", gap:"10px"}}>
										<div style={{margin:"0 10px 0 0", whiteSpace:"nowrap"}}>Paragraph</div>
										<input className={s.inputBox} value={v.ordering} style={{width:"80px"}}
											type="number" min="0" step="1"
											onChange={(e)=> {
												let nOrdering = Math.floor(e.target.value);
											
												sectionsData[indexV].ordering = nOrdering;
												setSectionsData([...sectionsData])
												
												const isInteger = (str) =>  {
													const parsedValue = parseInt(str, 10);
													return !isNaN(parsedValue) && Number.isInteger(parsedValue);
												}
												
												if (isInteger(nOrdering)) {
													updateOrdering(v.id, nOrdering)
												}
											}} />
									
										{(v.advOrdering == null) && (<div>
											<GreenButton isEnabled={v.advOrdering == null} clickedAction={()=>toggleHideParagraph(v, indexV)} bText={"Current: SHOW"} />
										</div>)}
										{(v.advOrdering != null) && (<div>
											<RedButton isEnabled={v.advOrdering != null} clickedAction={()=>toggleShowParagraph(v, indexV)} bText={"Current: HIDE"} />
										</div>)}
										{
											(v.sectionSentences.reduce((acc, current) => {
												return acc + (acc ? ' ' : '') + (current.sentence || '');
											}, '').length >= 100) && (<GreenButton isEnabled={true} clickedAction={()=>generateArticleComplexSentence(v, indexV)} bText={"Generate Complex Sentence"} />)

										}


										
										{
											(v.csItemId) && (<>
												<div className={s.tableRow} style={{flex: '0 0 50px', marginTop:"5px"}}>
													<Link className={s.detailButton} to={`/generalitem/${v.csItemId}`} target="_blank" rel="noopener noreferrer">
														{v.csItemId}
													</Link>
												</div>
											</>)
										}
									</div>
								</div>
						
						<div className={s['section-obj-holder']} key={v.id}>
						
							<div className={s['section-obj-detail-holder']}>
									<div className={s['section-thumbnail-path-holder']}>
									
									{
										
										(<div>
												{
													(v.imgPath) && (<div style={{position:"relative"}}>
														<div style={{position:"absolute"}}>
															<Image onClick={()=>{ setImageSelectionData({cSectionData:v, show:true})}} className={s['section-thumbnail-path']} fluid
															src={v.imgPath} rounded />
														</div>
														<div className={s.imgUncheckedBtnHolder}>
															<img className={s.imgUncheckedBtn} src={uncheckedPng}
																onClick={() => {removeImgFromSection(v, indexV)}}
															/>
														</div>
													</div>)
												}
												{
													(!v.imgPath) && <Image onClick={()=>{ setImageSelectionData({cSectionData:v, show:true})}} className={s['section-thumbnail-path-no-image']} fluid
													src={noImagePng} rounded />
												}
												</div>)
									}
									</div>
								</div>
							
							<div>
								<div>
								{
									v.sectionSentences.map((ss, indexSS)=>{

										return (
											<div key={indexV+'-'+ss.ordering}>
											
													<div style={{display:"flex", alignItems:"center", gap:"10px", marginTop:"5px", borderTop:"5px solid #c4c3c0"}}>
														<div style={{fontWeight:"bold", fontSize:"22px"}}>{indexSS+1}</div>
														{
															
															(ss.soundTrack) && (<div style={{width:"50px", height:"50px", display:"flex", alignItems:"center"}}>
																<SoundPlayer soundFile={ss.soundTrack}/>
															</div>)
														}
														{
															(indexSS != 0 && v.sectionSentences.length > 2 && rawData.itemType == 83) &&
															(<>
																<div style={{cursor:"pointer"}} className={(sectionsData[indexV].sectionSentences[indexSS].isInterpretation) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"}
																	onClick={()=>updateSentenceInterpretation(indexV, indexSS)}
																>{(sectionsData[indexV].sectionSentences[indexSS].isInterpretation) ? "Interpretation" : "Example"}{}</div>															
															</>)
														}		
														
														<div style={{textAlign:"left", margin:"5px 0"}}> 
															<div className={(isValidHeaderInteger(sectionsData[indexV].sectionSentences[indexSS].headerRate)) ? 
																"general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																style={{cursor:"pointer"}}
																onClick={()=>toggleSentenceHeaderRate(indexV, indexSS)}
															>Title</div>
														</div>
														{
															(isValidHeaderInteger(sectionsData[indexV].sectionSentences[indexSS].headerRate)) && (<div style={{display:"flex", gap:"5px", cursor:"pointer"}}>
															<div className={(sectionsData[indexV].sectionSentences[indexSS].headerRate == 1) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																onClick={()=>updateSentenceHeaderRate(indexV, indexSS, 1)}>1</div>
															<div className={(sectionsData[indexV].sectionSentences[indexSS].headerRate == 2) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																onClick={()=>updateSentenceHeaderRate(indexV, indexSS, 2)}>2</div>
															<div className={(sectionsData[indexV].sectionSentences[indexSS].headerRate == 3) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																onClick={()=>updateSentenceHeaderRate(indexV, indexSS, 3)}>3</div>
															<div className={(sectionsData[indexV].sectionSentences[indexSS].headerRate == 4) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																onClick={()=>updateSentenceHeaderRate(indexV, indexSS, 4)}>4</div>
															<div className={(sectionsData[indexV].sectionSentences[indexSS].headerRate == 5) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																onClick={()=>updateSentenceHeaderRate(indexV, indexSS, 5)}>5</div>
															
															</div>)
															
														}
														
														<div style={{textAlign:"left", margin:"5px 0"}}> 
															<div className={(sectionsData[indexV].sectionSentences[indexSS].isItalic) ? 
																"general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																style={{cursor:"pointer"}}
																onClick={()=>updateSentenceIsItalic(indexV, indexSS)}
															>Italic</div>
														</div>
														
														
														
													</div>
												
											
												
												<div className={s.sectionSentencesHolder}>
													<div>
													</div>
													
													<div style={{position: "relative"}}>
														
														<div className={(sectionsData[indexV].sectionSentences[indexSS].lastAction == 'JOB') ? s.containerLoader : s.containerLoaderDisabled}>
															<ClipLoader
																className={s.cliploader}
																loading={(sectionsData[indexV].sectionSentences[indexSS].lastAction == 'JOB')}
																size={10}
																aria-label="Loading Spinner"
																data-testid="loader"
															/>
														</div>
														<TextareaAutosize className={s.textAreaAuto} value={ss.sentence}  onChange={(e) => {
															setValue(e.target.value);
															ss.sentence = e.target.value;
														}}
															 />
													 {
														(ss.id) && (<div style={{display:"flex", alignItems:"center"}}>
															<TextareaAutosize className={s.textAreaAuto} value={ss.sentenceJson.hk}  onChange={(e) => {
																setValue(e.target.value);
																ss.sentenceJson.hk = e.target.value;
															}}/>
															<div>
																<GreenButton isEnabled={true} clickedAction={()=>saveTranslation(ss.id, ss.sentenceJson.hk)} bText={"Save"} />
															</div>
															<div style={{marginLeft:"10px"}}>
																<GreenButton isEnabled={true} clickedAction={()=>translateAndSave(indexV, indexSS, ss.id, ss.sentence)} bText={"Translate and save"} />
															</div>
															
														</div>)
													 }
													</div>
													
													
													<div style={{display:"flex", flexDirection:"column", borderRadius:"5px", padding:"5px", background:(indexSS != 0) ? "#00005522" : "white" }}>
														<div style={{display:"flex", width:"100%"}}>
															<div style={{marginRight:"5px"}}>
																<div className={(rawSectionsData[indexV].sectionSentences[indexSS].sentence != sectionsData[indexV].sectionSentences[indexSS].sentence) ? "general-green-btn general-green-btn-default ": "general-btn-disabled"} 
																	onClick={()=>updateSectionSentence(indexV, indexSS, ss.id, ss.sentence)}
																>save</div>
															</div>
															
															<div style={{marginRight:"5px"}}>
																<label htmlFor={"vu-"+indexV+"ss"+indexSS} className={"general-green-btn general-green-btn-default"} 
																	
																>Upload MP3
																	<input id={"vu-"+indexV+"ss"+indexSS} type="file" style={{display:"none"}} onChange={
																		async (e) => {
																			let path = await generalItemUpload(e.target.files[0]);
																			
																			if (path) {
																				deploySectionSentenceByAudio(indexV, indexSS, ss.id, path);
																			}
																			
																			
																		}} />
																
																
																</label>
															</div>
															<div style={{marginRight:"5px"}}>
																<div className={
																	(sectionsData[indexV].sectionSentences[indexSS].lastAction == 'TEXT') && 
																	sectionsData[indexV].sectionSentences[indexSS].sentence.trim() &&
																	(rawSectionsData[indexV].sectionSentences[indexSS].sentence === sectionsData[indexV].sectionSentences[indexSS].sentence)
																	? "general-green-btn general-green-btn-default ": "general-btn-disabled"} 
																	onClick={()=>deploySectionSentence(indexV, indexSS, ss.id)}
																>AWS</div>
															</div>
															
															<div style={{marginRight:"0px", marginLeft:"auto"}}>
																<div className="general-red-btn general-red-btn-default"
																	onClick={()=>removeSectionSentence(indexV, ss.id)}
																>X</div>
															</div>
														</div>
														
														
														{
															(indexSS != 0 && v.sectionSentences.length > 2) &&
															(<div style={{display:"flex", alignItems:"center", marginTop:"auto", marginBottom:"0", cursor:"pointer"}}>
																<div style={{marginRight:"auto", marginLeft:0}}>Ex type:</div>
																<div className={(sectionsData[indexV].sectionSentences[indexSS].isSimple) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} style={{marginRight:"10px"}}
																	onClick={()=>updateSentenceLevelSimple(indexV, indexSS)}
																>simple</div>
																<div className={(sectionsData[indexV].sectionSentences[indexSS].isAdvanced) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
																	onClick={()=>updateSentenceLevelAdvanced(indexV, indexSS)}
																>advanced</div>
															
															</div>)
														}			
													</div>
													
												</div>
												
												{ss.srtJson && (<div className={s.srtMainHolder}>
													<div className={s.srtMainHolderRow}>
													
													{
														
														<img className={s.srtIconClick} 
															src={clickPng} />
													}
													
													{
														ss.srtJson.map((sj, indexSj)=>(
															<span className={(/\d|[A-z]/.test(sj.word)) ? s.srtWordText : s.srtWordTextPuntucation} key={"longtext-" + indexSj}>																
																{
																	sj.word.split("").map((c, indexC)=>(<span key={"char-"+indexC} className={ isToggleChar(indexV, indexSS, indexSj, indexC) ? s.redChar: s.normalChar}
																	onClick={()=>toggleIndex(indexV, indexSS, indexSj, indexC)}>{c}</span>))
																}
																</span>)
														)
													}
													</div>
													<div className={s.srtMainHolderRow}>
													{
														
														advModify && <img className={s.srtIcon} 
															src={reorderPng} />
													}
													
													{
														advModify && ss.srtJson.map((sj, indexSj)=>(
															<span key={"dragtext-" + indexSj}
																className={s.dragText}
																draggable
																onDragOver={(e) => {e.preventDefault(); dragOver(e);}}
																onDragStart={(e) => {dragStart(e, indexV, indexSS, indexSj)}}
																onDrop={(e) => {drop(e, indexV, indexSS, indexSj)}}
																>
																{sj.word}
															</span>)
														)
													}
													</div>
													
													
													
													<div className={s.srtMainHolderRow}>
													{
														
														advModify && <img className={s.srtIcon} 
															src={deletePng} />
													}
													
													{
														advModify && (ss.srtJson.map((sj, indexSj)=>(
															<span key={"delete-" + indexSj} onClick={()=>{deleteWord(indexV, indexSS, indexSj)}}
																className={s.deleteText}>
																{sj.word}
															</span>)
														))
													}
													{
														advModify && <div className={s.addWordHolder} >
															<img className={s.srtIcon} src={addCirclePng}  onClick={()=>{addWord(indexV, indexSS)}} />
														</div>
														
													}
													</div>
													
													
													
													<div className={s.srtMainHolderRow}>
													{
														ss.srtJson.map((sj, indexSj)=>(
															<div key={"text-" + indexSj} className={s.srtHolder}>
																<input className={s.srtWord} type="text" value={sj.word} onChange={(e)=>{
																	setValue(e.target.value);
																	sj.word = e.target.value;
																	delete sj.highlight;
																}} size={Math.max(sj.word.length-1, 1)} />
																<input className={s.srtStartTime}  type="number" value={sj.startTime} onChange={(e)=>{
																	setValue(e.target.value);
																	sj.startTime = e.target.value;
																}}/>
																<div className={s.srtLabel}>
																	s
																</div>																
															</div>)
														)
													}
													{
														(
															JSON.stringify(sectionsData[indexV].sectionSentences[indexSS].srtJson) != JSON.stringify(rawSectionsData[indexV].sectionSentences[indexSS].srtJson)) && (<div className={s.srtUpdateBtn}>
															<div className="general-red-btn general-red-btn-default" onClick={()=>updateSrt(indexV, indexSS, ss.id)}>update SRT</div>
														</div>)
													}
													
													
													
													
													</div>
													
													
												</div>)
												}
												<div style={{display:"flex", gap:"10px"}}>
													<div style={{textAlign:"left", margin:"5px 0"}}> 
														<div className={(sectionsData[indexV].sectionSentences[indexSS].addDivider) ? 
															"general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
															style={{cursor:"pointer"}}
															onClick={()=>updateSentenceAddDivider(indexV, indexSS)}
														>Add Divider After</div>
													</div>
													
													<div style={{textAlign:"left", margin:"5px 0"}}> 
														<div className={(sectionsData[indexV].sectionSentences[indexSS].addLineSpace) ? 
															"general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
															style={{cursor:"pointer"}}
															onClick={()=>updateSentenceAddLineSpace(indexV, indexSS)}
														>Add Line Space</div>
													</div>
												</div>
											</div>
										)
									})
								}
								</div>
								<div className="general-red-btn general-red-btn-default" onClick={() => addSectionSentence(v.id)}>+ Sentence</div>
							</div>
						</div>
						</div>
						
						)
					}
				)
			}
			</div>
		</div>
		<div className="general-red-btn general-red-btn-default"
			onClick={()=>createNewSection()}
		>+Section</div>
			
		
		</div>)}
		{
			(toggle == 2) && (<div>
				<div style={{display:"flex", alignItems:"end"}}>
					
					<div className={s.wordOptionHolder}>
						<div className={((wordToggle == 2) ? (s.wordOptionChosen) : s.wordOption)}
							onClick={()=>{
								getWordsByItemId();
								setWordToggle(2)
							}}
						>Summary</div>
						<div className={((wordToggle == 1) ? (s.wordOptionChosen) : s.wordOption)}
							onClick={()=>setWordToggle(1)}
						>Detail</div>
					</div>
					{((wordToggle == 1)) && (<div className={s.wordOriginHolder}>
						<div style={{marginRight:"5px"}}>Word Origin:</div>
						<div className={s.wordOriginPointer} onClick={
							()=>{
								setWordOrigin(p=>{
									let newOrigin = (p==1) ? 0 : 1
									setGeneralStorage('wordListWordOrigin', newOrigin) 
									
									return newOrigin;
								})
							}
						}>{(wordOrigin == 1) ? "Defined" : "Article"}</div>
					</div>)}
				</div>
				{(wordToggle == 1) && (<WordsDetail itemId={itemId} wordOrigin={wordOrigin}/>)}
				{
					(wordToggle == 2) && (<>
						<div className={s.currentWordHolder}>
							<h5>Current Words</h5>
							{
								itemWords.map((w, indexW)=>(<div className={s.wordHolder + ' ' + ((indexW%2==1) ? s.wordHolderOdd:'')} key={indexW}>
									<img onClick={()=>removeWord(w.id)}className={s.deleteIcon} src={deletePng} />
									<div style={{width:"80px"}}>{w.id} </div>
									<div >{w.word} </div>
									<div style={{marginLeft:"auto", marginRight:"0", cursor:"pointer"}}>
										<div className={(w.isSimple) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} style={{marginRight:"10px"}}
											onClick={()=>updateWordLevelSimple(w.id, indexW)}
										>simple</div>
										<div className={(w.isAdvanced) ? "general-blue-btn general-blue-btn-default" : "general-btn-disabled"} 
											onClick={()=>updateWordLevelAdvanced(w.id, indexW)}
										>advanced</div>
									</div>
								
								</div>))
							}
						</div>
						<div>
							<textarea className={s.processWordTextAreaAuto} value={wordInput} rows={20} wrap='off' onChange={(e) => {
								setWordInput(e.target.value);
							}}/>
						</div>
						<div style={{display:"flex", justifyContent:"center"}}>
							<div>
								<GreenButton isEnabled={true} clickedAction={()=>processWords()} bText={"process word"} />
							</div>
							<div style={{marginLeft: "20px"}}>
								<BlueButton isEnabled={!clickAI} clickedAction={()=>AIWords()} bText={"AI word"} />
							</div>
							<div style={{marginLeft: "20px"}}>
								<RedButton isEnabled={true} clickedAction={()=>setIsCheckedAdvanced(p=>!p)} bText={(isCheckedAdvanced) ? "advanced" : "simple"} />
							</div>
						</div>
					</>)
				}
			</div>)
		}

		


		{ (toggle == 3 && !(rawData.itemType == 73 && shortReadingOverrideData)) && (<ItemQuestions itemId={itemId} itemType={rawData.itemType} />)}
		{ (toggle == 4) && (<SpeakingHints itemId={itemId} />)}
		
		{ (toggle == 5) && (<KeyListening itemId={itemId} itemType={rawData.itemType}/>)}
		{ (toggle == 6) && (<KeyItemBasic itemId={itemId} itemType={rawData.itemType}/>)}
		{ (toggle == 7) && (<SpeakingAnswers itemId={itemId} />)}
		{ (toggle == 8 ) && (<div className={s.currentWordHolder}>
					<h5>{(rawData.itemType == 77) ? "Ideas" : "Article"}</h5>
					{
						
						
							sectionsData.map((v, indexV)=>(<div key={indexV}>P{v.ordering}
								{
									v.sectionSentences.map((ss, indexSS)=>(<div>
										{ss.sentence}
									</div>))
								}
								<br/>
							</div>))
					}</div>)
		}
	
		{ (toggle == 9) && (<VIPWriting itemId={itemId} />)}
		{ (toggle == 12) && (<ListeningPartb itemId={itemId} />)}
	
		{ (toggle == 10) && (<ItemQuestionsOverview itemId={itemId} />)}
		
		{ (toggle == 11) && (<ComplexSentence itemId={itemId} />)}
	</div>);
	
}

function isValidHeaderInteger(value) {
    return Number.isInteger(value) && value >= 1 && value <= 5;
}